import React from 'react';
import RouteWarmer from './components/RouteWarmer';
import './App.css';

function App() {
  return <RouteWarmer />;
}

export default App;
